<script lang="ts">
import { computed, defineComponent, h, unref } from 'vue';

import { makeItemsProps, makeThemeProps, useItems, useRender } from '../../composable';

import { CdsBreadcrumbsItem } from './';

export const componentName = 'CdsBreadcrumbs';
export default defineComponent({
  name: componentName,
  props: {
    ...makeItemsProps(),
    ...makeThemeProps()
  },
  setup(props, { slots, expose }) {
    const { items } = useItems(props);

    const hasSlot = computed(() => !!slots.default);
    const isLastItem = (index: number) => unref(items).length - 1 === index;

    useRender(() =>
      h(
        'ui',
        {
          class: 'cds-breadcrumbs'
        },
        [
          unref(hasSlot)
            ? slots.default?.()
            : unref(items).map((item, idx) =>
                h(CdsBreadcrumbsItem, {
                  key: idx,
                  text: item.title,
                  to: item.props.to,
                  href: item.props.href,
                  theme: props.theme,
                  currentPage: isLastItem(idx)
                })
              )
        ]
      )
    );

    expose({
      items,
      isLastItem
    });

    return {};
  }
});
</script>

<style lang="scss">
@import './CdsBreadcrumbs';
</style>
